import React, { useContext } from 'react'
import { usePathname } from 'next/navigation'

import { trackClickTimeButton } from 'app/components/shared/Analytics/segment'
import { DateTimePickerContext } from 'components/form/DateTimePicker/helpers'

import { useAllTimeHelpers } from './helpers'
import { HourNumber, HourStyleProps, StyledButton } from './styles'

type Props = {
  index: number
}

export const Hour: React.FC<Props> = React.memo(function Hour({ index }) {
  const pathname = usePathname()

  const {
    setDateTimeState,
    dateTimeState: {
      props: { onChange },
      value,
    },
  } = useContext(DateTimePickerContext)
  const { hour, buttonText, isSelected, isDisabled } = useAllTimeHelpers(index)

  const handleHourClick = () => {
    trackClickTimeButton(
      { day: value.day ?? 0, month: value.month ?? 0, year: value.year ?? 0, time: `${hour}:00` },
      pathname ?? '',
    )

    setDateTimeState((state) => ({
      ...state,
      value: { ...state.value, time: hour },
    }))

    if (onChange) {
      const { day, month, year } = value
      if (day !== undefined && month !== undefined && year !== undefined) {
        onChange({ day, month, year, time: hour })
      } else {
        console.debug("onChange handler in Timepicker didn't fire, because Datepicker input is invalid")
      }
    }
  }

  const stylingProps: HourStyleProps = {
    isSelected,
    isDisabled: isDisabled,
  }

  return (
    <StyledButton onClick={handleHourClick} {...stylingProps}>
      <HourNumber fontSize="md" {...stylingProps}>
        {buttonText}
      </HourNumber>
    </StyledButton>
  )
})
